<template>
  <section id="setup" class="container">
    <section
      v-if="step === 1"
      id="setup-content"
      class="box padding w-buttons install step1"
    >
      <div class="w100 txt-center">
        <h1>Precisamos completar seu cadastro!</h1>
        <p class="margin-top-m">
          Preencha as informações abaixo para iniciar sua jornada como:
          <b>Parceiro Bopoty</b>
        </p>
      </div>
      <div class="w100 txt-center margin-top-l">
        <p class="margin-top-m">
          As informações abaixo serão útilizadas para efetuar os pagamentos das comissões.
        </p>
        <p class="margin-top-s">
          <b>Atenção:</b> Estes dados não podem ser alterados posteriormente.
        </p>
      </div>

      <validation-observer ref="form1" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(updateAccount)">
          <div class="box-content">
            <div class="flex-1 w100">
              <div class="txt-center">
                Você vai atuar com CNPJ ou CPF?
              </div>
              <div class="flex center margin-top-s">
                <div class="flex-1 switcher">
                  <input
                    type="radio"
                    id="CNPJ"
                    v-model="documentType"
                    value="CNPJ"
                  />
                  <label for="CNPJ">CNPJ</label>
                  <input
                    type="radio"
                    id="CPF"
                    v-model="documentType"
                    value="CPF"
                  />
                  <label for="CPF">CPF</label>
                </div>
              </div>
            </div>
            <div
              v-if="documentType === 'CNPJ'"
              class="flex-1 w100 margin-top-m"
            >
              <validation-provider
                name="CNPJ"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field flex-1 w100 group-input margin-top-m"
                  :class="{ errors: errors[0] }"
                >
                  <label>CNPJ</label>
                  <the-mask
                    :mask="['##.###.###/####-##']"
                    v-model="document"
                    placeholder="XX.XXX.XXX/XXXX-XX"
                    class="input"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                name="Razão Social"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field flex-1 w100 group-input margin-top-m"
                  :class="{ errors: errors[0] }"
                >
                  <label>Razão Social</label>
                  <input
                    class="input"
                    type="text"
                    v-model="corporateName"
                    placeholder=""
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </div>
            <div v-else class="flex-1 w100 margin-top-m">
              <validation-provider
                name="CPF"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field flex-1 w100 group-input margin-top-m"
                  :class="{ errors: errors[0] }"
                >
                  <label>CPF</label>
                  <the-mask
                    :mask="['###.###.###-##']"
                    v-model="document"
                    placeholder="XXX.XXX.XXX-XX"
                    class="input"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                name="Nome Completo"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field flex-1 w100 group-input margin-top-m"
                  :class="{ errors: errors[0] }"
                >
                  <label>Nome Completo</label>
                  <input
                    class="input"
                    type="text"
                    v-model="corporateName"
                    placeholder=""
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="">
            <div class="flex middle center">
              <div class="flex-1 flex middle form-field group-input">
                <input type="checkbox" v-model="checkTermos" id="termos" name="termos"  ref="termos" style="width:20px; margin-top:0px; margin-right: 10px;">
                <label @click="$refs.termos.click()">Aceito os termos de uso do programa.</label>
              </div>
            </div>
            <p>
              Ao continuar você está concordando com nossos termos de uso do programa. Para ler os termos de uso <a :href="linkTermos" target="_blank">clique aqui.</a>
            </p>
          </div>
          <div class="buttons flex center">
            <button class="button primary medium" type="submit" >
              PREENCHER DADOS BANCARIOS
            </button>
          </div>
        </form>
      </validation-observer>
    </section>


    <section
      v-if="step === 2"
      id="setup-content"
      class="box padding w-buttons install step1"
    >
      <div class="w100 txt-center">
        <h1>Precisamos da sua chave PIX!</h1>
        <p class="margin-top-m">
          Os dados preenchidos na tela anterior devem ser os mesmo do titular da Conta bancária da chave Pix informada. Ou seja, mesmo nome e CPF/CNPJ.
        </p>
      </div>
      <validation-observer ref="form2" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(updateAccount)">
          <div class="box-content">
            <div class="margin-top-l">
              <validation-provider
                name="nome do banco"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Nome do Banco
                  <input type="text" v-model="bankName" placeholder="Nome do Banco" />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <div class="form-field item group-input ">
                Tipo de chave
                <div class="margin-top-s">
                  <select
                    class="input"
                    v-model="typePix"
                  >
                    <option
                      v-for="(v, k) in typesPix"
                      :key="k"
                      :value="v.value"
                    >
                      {{ v.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="margin-top-m">
                <validation-provider
                  name="chave pix"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-field item group-input "
                    :class="{ errors: errors[0] }"
                  >
                    Chave Pix
                    <input type="text" v-model="pix" placeholder="Chave Pix" />
                    <span class="erros-alert">{{ errors[0] }}</span>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="buttons flex center">
            <div class="button secondary medium" @click="step = 1">
              VOLTAR
            </div>
            <button type="submit" class="button primary medium" style="margin-left:16px">
              COMEÇAR A VENDER!
            </button>
          </div>
        </form>
      </validation-observer>
    </section>

  </section>
</template>

<script>
import { mapState } from "vuex";

import { Account, updateAccount } from "@/services/account";

export default {
  name: "Onboarding",
  props: {
    msg: String,
  },
  data() {
    return {
      step: 1,
      documentType: "CNPJ",
      document: "",
      corporateName: "",
      bankName: "",
      typePix: "",
      pix: "",
      checkTermos: false,
      typesPix: [
        {
          value: 'PHONE',
          label: 'TELEFONE'
        },
        {
          value: 'CPF',
          label: 'CPF'
        },
        {
          value: 'CNPJ',
          label: 'CNPJ'
        },
        {
          value: 'EMAIL',
          label: 'EMAIL'
        },
        {
          value: 'RANDOM',
          label: 'ALEATÓRIA'
        },
      ]
    };
  },
  mounted() {
    this.getAccountInfo();
  },
  watch: {
    documentType() {
      this.document = "";
      this.corporateName = "";
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    linkTermos(){
      return 'https://drive.google.com/file/d/1KKKChia4h4DkD4ipax_xDSTxk2oL_hu2/view?usp=drive_link'
    }
  },
  methods: {
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
      });
    },
    updateAccount() {
      if (this.step == 1) {

        if (!this.checkTermos) {
          this.$toast.error({
            title:'Erro',
            message:'Você precisa aceitar os termos de uso do programa para continuar.'
          })
          return
        }
        this.step = 2
        return
      }

      let params = {
        document: this.document,
        document_type: this.documentType,
        corporate_name: this.corporateName,
        bank_name: this.bankName,
        type_pix: this.typePix,
        pix: this.pix,
      };

      updateAccount(params)
        .then((result) => {
          this.$toast.success({
            title: "Sucesso",
            message: "Conta atualizada com sucesso",
          });

          this.$store.dispatch("setAccount", result);
          this.$router.push({ name: "Home" });

        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao atualizar conta",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#setup {
  margin-top: 100px;
  label {
    font-weight: 800;
  }
}
</style>
